import { css } from '@emotion/react';

import { breakpoints } from '@coursera/cds-core';

export const compactBlockStyle = css`
  padding: 48px 0;

  ${breakpoints.down('sm')} {
    padding: 32px 0;
  }
`;

export const sharedMarkdownStyles = css`
  * {
    font-family: var(--cds-font-family-source-sans-pro) !important;
    color: inherit !important;
  }

  p {
    font: var(--cds-typography-body1) !important;
    font-size: 20px !important;
    line-height: 150% !important;
    letter-spacing: -0.02em !important;
    min-height: 1rem !important;
  }

  h1 {
    /* stylelint-disable-next-line cds-stylelint/cds-design-tokens */
    font: var(--cds-typography-display1) !important;
  }

  h2 {
    /* stylelint-disable-next-line cds-stylelint/cds-design-tokens */
    font: var(--cds-typography-display2) !important;
  }

  h3 {
    font: var(--cds-typography-title3) !important;
    font-size: 28px !important;
    font-weight: 600 !important;
  }

  h4 {
    font: var(--cds-typography-title4) !important;
    font-size: 24px !important;
    font-weight: 600 !important;
  }

  h5 {
    font: var(--cds-typography-title4) !important;
    font-size: 22px !important;
    font-weight: 600 !important;
  }

  h6 {
    font: var(--cds-typography-title4) !important;
    font-size: 20px !important;
    font-weight: 600 !important;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    line-height: normal !important;
    letter-spacing: -0.03em !important;
  }
`;
